export default __webpack_public_path__ + "static/media/logo.98541a1c.png";